
import { locale } from './globals.js';
import { insertAfter } from './toolbox.js';

class HomeHero {
  constructor(el) {
    if(!el) return false;
    this.el = el;
    this.covers = this.el.querySelector('[data-hero-covers]');
    this.contents = this.el.querySelector('[data-hero-contents]');
    this.rtl = (locale.dir == 'rtl');
    this.initSliders();
    if (this.covers.children.length > 1) {
      this.initPager();
    }
  }
  initSliders () {
    this.coverSldr = new Flickity(this.covers, {
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      rightToLeft: this.rtl,
      autoPlay: 5000
      // selectedAttraction: 0.01,
      // friction: 0.15
    });
    this.contentSldr = new Flickity(this.contents, {
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      rightToLeft: this.rtl
    });

    this.coverSldr.on('change', (index) => {
      this.contentSldr.select(index);
      this.coverSldr.playPlayer()
    });
    this.contentSldr.on('change', (index) => {
      this.coverSldr.select(index);
      this.updateTheme(index);
    });
    this.updateTheme(0);
  }
  initPager () {
    let pager = document.createElement('div');
    pager.classList.add('pager-arrows');
    pager.innerHTML = `${this.pagerButton('prev')}${this.pagerButton('next')}`;
    insertAfter(pager, this.contents);
    pager.querySelector('.arrow.prev').addEventListener('click', () => {
      this.contentSldr.stopPlayer();
      this.coverSldr.stopPlayer();
      this.contentSldr.previous();
    });
    pager.querySelector('.arrow.next').addEventListener('click', () => {
      this.contentSldr.stopPlayer();
      this.coverSldr.stopPlayer();
      this.contentSldr.next();
    });
  }
  updateTheme(index) {
    let theme = this.contentSldr.cells[index].element.getAttribute('data-theme');
    if (!theme) theme = 'default';
    this.el.setAttribute('data-theme', theme);
  }
  pagerButton (dir) {
    return `<button type="button" class="custom arrow ${dir}" data-pager="prev"> <i class="fal fa-chevron-circle-${locale[dir]} icon"> </i></button>`
  }
  
}
export default function () {
  new HomeHero(document.querySelector('[data-home-hero]'));
}
